module.exports = __webpack_public_path__ + "tables/media/ui-elements.300b3ba5.svg";